module.exports = __webpack_public_path__ + "static/SPQR-62186c1aebeed84fc387b8b685f2ea1f.webp";